import { fetchRequest, SADUKA_TRANSPORT_PREFIX } from '../utils/apiUtils'
import { loadEntity, deleteEntity } from 'redux-entity';
import { stringify } from 'query-string';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';
import config from 'cityads-v3/config';
import { mapDir } from 'cityads-v3/reducers/offers'
import { mapHash } from 'cityads-v3/utils/arrayUtils';

import {
  MOCK_DELIVERY_STATUSES,
  MOCK_FINANCE_APPLICATION_STATUSES,
  MOCK_OFFERS,
  MOCK_FINANCIAL_OFFERS,
  MOCK_FINANCE_APPLICATIONS,
  MOCK_FINANCE_INTERACTED_APPLICATIONS,
  MOCK_BACKURLS,
  MOCK_PARKED_DOMAINS,
  MOCK_REQUESTS_HISTORY,
} from './entity.mock';

import {
  monitoringAlertsMap
} from 'cityads-v3/containers/Manager/Monitoring/misc';

export const API = {

  projects: {
    url: '/saduka/projects?sort=name&sort_asc=true&parent_id=41&instance_id=1',
    map: data => data.project.map(item => ({...item, id: +item.id}))
  },

  alertTypes: {
    url: '/saduka/monitoring/alertTypes',
    map: data => data.alertType.map(item => ({...item, id: +item.id}))
  },

  alertSlices: {
    url: '/saduka/monitoring/alertSlices',
    map: data => data.alertSlice.map(item => ({...item, id: +item.id}))
  },

  alertMetrics: {
    url: '/saduka/monitoring/alertMetrics',
    map: data => data.alertMetric.map(item => ({...item, id: item.id}))
  },

  advertisers: {
    aliasList: 'advertisersList',
    url: params => `/saduka/advertisers?adv_filter=${params.filter || ''}&perpage=${params.perpage || config.PAGE_DEFAULT_LIMIT}`,
    map: data => data.advertisers.map(item => ({...item, id: +item.id}))
  },

  advertisersList: {
    url: params => `/saduka/advertisers?adv_filter=${params.filter || ''}&perpage=${params.perpage || config.PAGE_DEFAULT_LIMIT}&${(params.ids ?? []).map(id => `ids[]=${id}`).join('&')}`,
    map: data => data.advertisers.map(item => ({...item, id: +item.id})),
    append: true
  },

  categories: {
    url: ({ api, ...params }) => `/saduka/categories?${stringify(params)}`,
    map: data => ({
      ...data,
      category: data.category.map(item => ({
        ...item,
        depth: +item.depth,
        id: +item.id,
        parent: +item.parent,
        type_action: +item.type_action,
      })),
    })
  },

  categoryTree: {
    url: () => `/saduka/category/tree`,
    map: data => mapHash(data.category.children, 'category_ids')
  },

  couponCategoryTree: {
    url: () => `/saduka/category/tree?for_coupons=1`,
    map: data => mapHash(data.category.children, 'category_ids')
  },

  financeOfferField: {
    url: '/saduka/financeApi/offerFields',
    map: data => data.financeOfferField
  },

  financeProduct: {
    url: '/saduka/financeApi/products',
    map: data => (data.financeProduct || []).map(item => ({...item, offerIds: []}))
  },

  financeProductGroup: {
    url: '/saduka/financeApi/productGroups',
    map: data => data.financeProductGroup?.map(item => ({ ...item, productIds: [] })),
  },

  jobOpportunity: {
    url: '/saduka/jobOpportunities',
    map: data => data.jobOpportunity ?? []
  },

  jobOpportunitySection: {
    url: '/saduka/jobOpportunitySections',
    map: data => data.jobOpportunitySection ?? []
  },

  managers: {
    url: params => '/saduka/managers?perpage=1000&mng_filter=' + (params.filter || ''),
    map: data => data.managers.map(item => ({...item, id: +item.id}))
  },

  webmasters: {
    aliasList: 'webmasterList',
    url: params => `/saduka/webmasters?wm_filter=${params.filter || ''}&perpage=${params.perpage || config.PAGE_DEFAULT_LIMIT}`,
    map: data => data.webmasters.map(item => ({...item, id: +item.id})),
  },

  accountManagers: {
    url: params => '/saduka/managers?perpage=1000&is_account_manager=true&mng_filter=' + (params.filter || ''),
    map: data => data.managers.map(item => ({...item, id: +item.id}))
  },

  activeAccountManagers: {
    url: params => '/saduka/managers?perpage=1000&is_account_manager=true&is_active=true&mng_filter=' + (params.filter || ''),
    map: data => data.managers.map(item => ({...item, id: +item.id}))
  },

  publisherManagers: {
    url: params => '/saduka/managers?perpage=1000&is_publisher_manager=true&mng_filter=' + (params.filter || ''),
    map: data => data.managers.map(item => ({...item, id: +item.id}))
  },

  activePublisherManagers: {
    url: params => '/saduka/managers?perpage=1000&is_publisher_manager=true&is_active=true&mng_filter=' + (params.filter || ''),
    map: data => data.managers.map(item => ({...item, id: +item.id}))
  },

  monitoringAlerts: {
    url: '/saduka/monitoring/alerts',
    body: params => JSON.stringify(params.body),
    map: monitoringAlertsMap,
    method: 'POST',
  },

  webmasterList: {
    url: params => `/saduka/webmasters?wm_filter=${(params.filter || '')}&perpage=1000&${(params.ids ?? []).map(id => `ids[]=${id}`).join('&')}`,
    map: data => data.webmasters.map(item => ({...item, id: +item.id})),
    append: true
  },

  offerList: { // переименовать под мониторинг
    url: params => `/saduka/selectList/offers/monitoring?name=${(params.filter || '')}&perpage=1000&${(params.ids ?? []).map(id => `ids[]=${id}`).join('&')}`,
    map: data => data.offer.map(item => ({...item, id: +item.id})),
    append: true
  },

  offers: {
    aliasList: 'offerList',
    url: params => `/saduka/selectList/offers/${params.name}?name=${params.filter ?? ''}&perpage=${params.perpage || config.PAGE_DEFAULT_LIMIT}`,
    map: data => data.offer.map(item => ({...item, id: +item.id})),
    mock: MOCK_OFFERS
  },

  offerDescriptions: {
    url: params => `/saduka/offerDescriptions?${stringify({ids: params.ids}, {arrayFormat: 'bracket'})}`,
    map: data => data.offerDescription.map(({ id, language_id, offer_id, type_id, ...rest }) => ({
      id: +id,
      language_id: +language_id,
      offer_id: +offer_id,
      type_id: +type_id,
      ...rest,
    }))
  },

  offersList: {
    aliasList: 'offersListAllLoaded',
    url: params => `/saduka/offers?${stringify(params.filter ?? '', { arrayFormat: 'bracket' })}`,
    map: data => ({
      ...data,
      offer: data.offer.map(offer => ({
        ...offer,
        id: +offer.id,
        category_level2: +offer.category_level2
      })),
    }),
  },

  offersListAllLoaded: {
    url: params => `/saduka/offers?${stringify(params.filter ?? '', { arrayFormat: 'bracket' })}`,
    map: data => ({
      ...data,
      offer: data.offer.map(offer => ({
        ...offer,
        id: +offer.id,
        category_level2: +offer.category_level2
      })),
    }),
    append: true
  },

  backurlOffers: {
    url: params => `/saduka/offers?${stringify({ name: params.name, ...params.filter }, { arrayFormat: 'comma' })}`,
    map: data => data.offer,
  },

  offersWithTraffic: {
    url: params => `/saduka/selectList/offers/backurlGroup?perpage=100&${params.filter ?? ''}`,
    map: data => data.offer.map((item) => ({...item, id: +item.id}))
  },

  deliveryStatuses: {
    url: () => `/saduka/finance/applicationDeliveryStatuses`,
    map: data => data.applicationDeliveryStatus.map(item => ({...item, id: item.code})),
    mock: MOCK_DELIVERY_STATUSES
  },

  financeApplicationStatuses: {
    url: params => `/saduka/finance/applicationStatuses/${params.filter ?? ''}`,
    map: data => data.applicationStatus.map(item => ({...item, id: +item.id})),
    mock: MOCK_FINANCE_APPLICATION_STATUSES
  },

  financialOffers: {
    aliasList: 'financialOffersList',
    url: params => `/saduka/financialOffers?${params.params ?? ''}&name=${params.filter ?? ''}`,
    map: data => data.offer,
    mock: MOCK_FINANCIAL_OFFERS
  },

  financialOffersList: {
    url: params => `/saduka/financialOffers?${params.params ?? ''}&name=${params.filter ?? ''}`,
    map: data => data.offer,
    append: true
  },

  financeApplications: {
    url: params => {
      const { filters } = params;
      filters.page = filters.page ?? 1;
      filters.perpage = filters.perpage ?? config.PAGE_DEFAULT_LIMIT;
      return `/saduka/finance/applications?${stringify(filters, {arrayFormat: 'bracket'})}`;
    },
    map: data => data,
    mock: MOCK_FINANCE_APPLICATIONS
  },

  financeApplicationsCount: {
    url: params => {
      const { filters } = params;
      return `/saduka/finance/applications/count?${stringify(filters, {arrayFormat: 'bracket'})}`;
    },
    map: data => data,
  },

  financeInteractedApplications: {
    url: params => {
      const { filters } = params;
      filters.page = filters.page ?? 1;
      filters.perpage = filters.perpage ?? config.PAGE_DEFAULT_LIMIT;
      return `/saduka/finance/interactedApplications?${stringify(filters, {arrayFormat: 'bracket'})}`;
    },
    map: data => data,
    mock: MOCK_FINANCE_INTERACTED_APPLICATIONS
  },

  financeInteractedApplicationsCount: {
    url: params => {
      const { filters } = params;
      return `/saduka/finance/interactedApplications/count?${stringify(filters, {arrayFormat: 'bracket'})}`;
    },
    map: data => data,
  },

  dashboardGraphs: {
    url: ({period, type}) => `/saduka/dashboard/stat?${stringify({period, type}, {arrayFormat: 'bracket'})}`,
    map: data => data
  },

  topOffers: {
    url: () => `/saduka/topOffers`,
    map: data => data.topOffer.sort((a,b) => a.sort - b.sort),
  },

  promoOffers: {
    url: () => `/saduka/promoOffers?perpage=1000`,
    map: data => data.promoOffer,
  },

  dashboardPayments: {
    url: ({ period, month }) => `/saduka/webmasterPayments?${stringify({ period, month })}`,
    map: data => data
  },

  dashboardPromos: {
    url: () => `/saduka/interestingOffers`,
    map: data => data.offer.map(item => +item),
  },

  backurls: {
    url: ({ page, perpage, ids }) => `/saduka/backurls?${stringify({ page, perpage, ids })}`,
    map: data => data,
    mock: MOCK_BACKURLS
  },

  parkedDomains: {
    url: ({ api, useMock, ...params }) => `/saduka/parkedDomains?${stringify(params)}`,
    map: data => ({
      ...data,
      parkedDomain: data.parkedDomain?.map(item => ({
        id: +item.id,
        domain: item.name,
        comment: item.comment,
        status: item.status_id,
        addedAt: new Date(item.created_at),
        domainType: item.type,
      }))
    }),
    mock: MOCK_PARKED_DOMAINS
  },

  parkedDomainStatuses: {
    url: () => `/saduka/parkedDomainStatuses?page=1&perpage=1000`,
    map: data => (data.parkedDomainStatus ?? [])
  },

  referrals: {
    url: ({ page, perpage, period, referralId, ids }) => {
      const query = stringify({
        page: page ?? 1,
        perpage: perpage ?? config.PAGE_DEFAULT_LIMIT,
        ids,
        period,
        referral_id: referralId || undefined,
      }, { arrayFormat: 'bracket' });

      return `/saduka/referrals?${query}`
    },
    map: data => data,
  },

  totalReferralsCount: {
    url: '/saduka/referrals',
    map: data => data.meta.total,
  },

  showcases: {
    url: ({ api, ...params }) => `/saduka/showcases?${stringify(params)}`,
    map: data => ({
      ...data,
      showcase: data.showcase.map(item => ({
        ...item,
        id: +item.id
      }))
    })
  },

  showcaseDisplayTypes: {
    url: `/saduka/showcaseDisplayTypes?${stringify({ perpage: 1000 })}`,
    map: data => ({
      ...data,
      showcaseDisplayType: data.showcaseDisplayType.map(item => ({
        ...item,
        id: +item.id
      })).sort((a, b) => a.sort - b.sort)
    })
  },

  showcaseTemplates: {
    url: `/saduka/showcaseTemplates?${stringify({ perpage: 1000 })}`,
    map: data => ({
      ...data,
      showcaseTemplate: data.showcaseTemplate.map(item => ({
        ...item,
        id: +item.id
      })).sort((a, b) => a.sort - b.sort)
    })
  },

  showcaseDomains: {
    url: `/saduka/showcaseDomains?${stringify({ perpage: 1000 })}`,
    map: data => ({
      ...data,
      showcaseDomain: data.showcaseDomain.map(item => ({
        ...item,
        id: +item.id
      }))
    })
  },

  geos: {
    url: ({ api, ...params }) => `/saduka/geos?${stringify(params)}`,
    map: data => ({
      ...data,
      geo: data.geo.map(item => ({
        ...item,
        id: +item.id,
        parent_id: +item.parent_id,
      }))
    })
  },

  regionTree: {
    url: () => `/saduka/geo/tree?area_id=0`,
    map: data => data.geo.map(item => mapDir(item, 'children'))
  },

  trafficTypes: {
    url: ({ api, aliasName, ...params }) => `/saduka/trafficTypes?${stringify({ perpage: 1000, ...params })}`,
    map: data => data.trafficType.map(item => ({
      ...item,
      id: +item.id,
      special: !!item.special,
      position: +item.position,
    }))
  },

  trafficChannels: {
    url: ({ api, ...params }) => `/saduka/trafficChannels?${stringify({ perpage: 10000, is_active: true, ...params })}`,
    map: data => data.trafficChannel.map(item => ({
      ...item,
      id: +item.id,
      webmaster_user: +item.webmaster_user,
    })).sort((a, b) => a.id - b.id)
  },

  creativeList: {
    url: ({ api, ...params }) => `/saduka/creatives?${stringify(params, { arrayFormat: 'bracket' })}`,
    map: data => data
  },

  creativeStatuses: {
    url: ({ api, ...params }) => `/saduka/creativeStatuses?${stringify(params, { arrayFormat: 'bracket' })}`,
    map: data => ({
      ...data,
      creativeStatus: data?.creativeStatus.map(status => ({
        ...status,
        id: +status.id,
      }))
    })
  },

  creativeStatusesList: {
    url: ({ api, ...params }) => `/saduka/creativeStatusCounter?${stringify(params, { arrayFormat: 'bracket' })}`,
    map: data => data
  },

  agreementsWithUpdate: {
    url: ({ api, ...params }) => `/saduka/agreements/withUpdate?${stringify(params, { arrayFormat: 'bracket' })}`,
    map: data => ({
      ...data,
      agreement: data.agreement.map(item => ({
        ...item,
        id: +item.id
      }))
    })
  },

  tools: {
    url: ({ api, ...params }) => `${SADUKA_TRANSPORT_PREFIX}/tools/countOffersBelongingToEntity?is_active=true`,
    map: data => ({
      ...data,
      tool: data.tool.map(item => ({
        ...item,
        id: +item.id,
        sort: +item.sort,
        is_active: !!+item.is_active,
        offers_count: +item.offers_count
      }))
    })
  },

  subscriptionStatuses: {
    url: ({ api, ...params }) => `${SADUKA_TRANSPORT_PREFIX}/subscriptionStatuses?perpage=1000`,
    map: data => ({
      ...data,
      subscriptionStatus: data.subscriptionStatus.map(item => ({
        ...item,
        id: +item.id
      }))
    })
  },

  webmasterVerificationStatuses: {
    url: ({ api, ...params }) => `${SADUKA_TRANSPORT_PREFIX}/webmasterVerificationStatuses`,
    map: data => data.webmasterVerificationStatuses.map(item => ({
      ...item,
      id: +item.id,
    }))
  },

  internalAccounts: {
    url: ({ api, ...params }) => `/saduka/internalAccounts`,
    map: data => ({
      ...data,
      internalAccount: data.internalAccount.map(item => ({
        ...item,
        id: +item.id
      }))
    })
  },

  bannerSize: {
    url: ({ api, ...params }) => `/saduka/bannerSizes?${stringify(params, { arrayFormat: 'bracket' })}`,
    map: data => ({
      bannerSize: data.bannerSize.map(item => ({
        ...item,
        id: +item.id,
      }))
    }),
  },

  promo: {
    aliasList: 'promoListAllLoaded',
    url: ({ api, ...params }) => `/saduka/promos?${stringify(params, { arrayFormat: 'bracket' })}`,
    map: data => ({
      ...data,
      promo: data.promo.map(item => ({
        ...item,
        id: +item.id,
        type: +item.type
      }))
    })
  },

  promoListAllLoaded: {
    url: ({ api, ...params }) => `/saduka/promos?${stringify(params, { arrayFormat: 'bracket' })}`,
    map: data => ({
      ...data,
      promo: data.promo.map(item => ({
        ...item,
        id: +item.id,
        type: +item.type
      }))
    }),
    append: true
  },

  bannerRotatorTool: {
    url: ({ api, ...params }) => `/saduka/bannerRotators?${stringify(params, { arrayFormat: 'bracket' })}`,
    map: data => ({
      ...data,
      bannerRotator: data.bannerRotator.map(item => ({
        ...item,
        id: +item.id,
        add_new_offer: !!item.add_new_offer,
        enable_optimization: !!item.enable_optimization,
        banner_ids: item.banner_ids.map(Number),
        banner_sizes: item.banner_sizes.map(Number),
        category_ids: item.category_ids.map(Number),
        exclude_banner_ids: item.exclude_banner_ids.map(Number),
        exclude_category_ids: item.exclude_category_ids.map(Number),
        exclude_offer_ids: item.exclude_offer_ids.map(Number),
        offer_ids: item.offer_ids.map(Number),
      }))
    })
  },

  requestHistory: {
    url: ({ api, ...params }) => `/saduka/offer/connectRequests?${stringify(params, { arrayFormat: 'bracket' })}`,
    map: data => ({
      ...data,
    }),
    mock: MOCK_REQUESTS_HISTORY,
  },

}

export function _fetchEntity(dispatch, params) {
  const controller = new AbortController();
  const signal = controller.signal;
  const _dispatch = dispatch({
    type: 'FETCH_ENTITY_REQUEST'
  });

  const inf = API[params.api];
  if (!inf) {
    console.error('fetchEntity не существует сущность', params);
    return;
  }

  loadEntity(params.aliasName ?? params.api, new Promise((resolve, reject) => {
    const url = typeof inf.url === 'function' ? inf.url(params) : inf.url;
    fetchRequest(url, {
      options: {
        signal: window ? signal : undefined,
        method: inf.method || 'GET',
        credentials: 'include',
        body: inf.body && inf.body(params),
        headers: inf.method === 'POST' ? {
          'Content-Type': 'application/json'
        } : {},
      },
    }, _dispatch)
      .then(data => {
        const mappedData = inf.map(data);

        if (inf.aliasList) {
          appendEntity(inf.aliasList, mappedData, dispatch);
        }

        resolve( mappedData );
      })
      .catch(e => {
        if (config.USE_MOCK && params.useMock) {
          const mappedData = inf.map(inf.mock);
          if (inf.aliasList) {
            appendEntity(inf.aliasList, mappedData, dispatch);
          }
          resolve( mappedData )
        } else {
          reject(e);
        }
      });

  }), {
    append: !!inf.append
  })(dispatch);

  return controller;
}

function appendEntity(name, data, dispatch) {
  const promise = new Promise((resolve, reject) => {
    resolve(data);
  });

  loadEntity(name, promise, {
    append: true
  })(dispatch);
}

export function modifyEntity({entityName, id, item}) {
  return (dispatch, getState) => {
    const newItems = (getState().entities?.[entityName]?.data ?? [])
      .map(lastItem => lastItem.id === id ? ({...lastItem, ...item}) : lastItem);
    loadEntity(entityName, new Promise((resolve, reject) => resolve(newItems)))(dispatch);
  }
}

export function fetchEntity(params) {
  if (typeof window !== 'undefined' && window.__storybook?.disableFetchEntity) {
    return () => () => ({ abort: () => {} })
  }

  return (dispatch, getState) => {
    if (getState().entities.fakeFetch) {
      return () => {};
    }

    return _fetchEntity(dispatch, params);
  }
}

export function removeEntity(...params) {
  return deleteEntity(...params)
}
